import React from 'react';
import Hero from '../components/Hero';
import Mission from '../components/Mission';

function Home() {
  return (
    <>
      <Hero />
      <Mission />
    </>
  );
}

export default Home;
